import { FC } from 'react'
import { RowActions, useModal } from '../../../../../../components'
import { FinanceiroAtendimentosModal } from '../../components/modal/FinanceiroAtendimentosModal'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { getValoresByAtendimento } from '../../core/_requests'
import { IconPaths } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  atendimento: AtendimentoList
}

/** Ação única da linha: adicionar o atendimento a uma fatura (sempre visível, sem menu). */
export const FinanceiroAtendimentosActionsCell: FC<IProps> = ({ atendimento }) => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () =>
    showModal({
      title: t('modal.financeiro_atendimentos', { name: atendimento.protocolo }),
      content: (
        <FinanceiroAtendimentosModal
          idAtendimento={Number(atendimento.id)}
          idEmpresa={Number(atendimento.empresa?.id)}
        />
      ),
      fetchers: {
        valoresAtendimento: () => getValoresByAtendimento(Number(atendimento.id)),
      },
    })

  return (
    <RowActions
      itemName={`atendimento ${atendimento.protocolo ?? ''}`.trim()}
      primaryAction={{
        label: t('dropdown_item.adicionar_fatura'),
        onClick: openModal,
        icon: IconPaths.Add,
      }}
    />
  )
}
